import { ComponentType } from '../types';
const HTML_HEADING = new Set([ComponentType.Text]);
const STRUCTURED_HEADING = new Set([ComponentType.TextEffectsShook, ComponentType.TextEffectsBauhaus, ComponentType.TextEffectsLetterPress, ComponentType.TextEffectsMatrix, ComponentType.TextEffectsOutlineOut, ComponentType.TextEffectsRetro, ComponentType.TextEffectsSticker, ComponentType.TextEffectsStriped, ComponentType.TextEffects3d, ComponentType.TextEffectsGlass, ComponentType.TextEffectsGlitch, ComponentType.TextEffectsNeonSign, ComponentType.TextEffectsNoisy]);

// Type representing the source from which a component's heading should be resolved or updated.
export let ComponentHeadingSource = /*#__PURE__*/function (ComponentHeadingSource) {
  ComponentHeadingSource["HTML"] = "HTML";
  ComponentHeadingSource["STRUCTURED"] = "STRUCTURED";
  ComponentHeadingSource["UNKNOWN"] = "UNKNOWN";
  return ComponentHeadingSource;
}({});
export const getComponentHeadingSource = componentType => {
  if (HTML_HEADING.has(componentType)) {
    return ComponentHeadingSource.HTML;
  }
  if (STRUCTURED_HEADING.has(componentType)) {
    return ComponentHeadingSource.STRUCTURED;
  }
  return ComponentHeadingSource.UNKNOWN;
};
//# sourceMappingURL=get-component-heading-source.js.map